const compareHeader = {
    props: {
        watchSelector:{
            type: String,
            default: ''
        }
    },
    data(){
        return {
            show: false
        }
    },
    template: 
    `<div class="b-compare-header-wrap">
        <transition name="slide-down">
            <div v-show="show" class="b-compare-header">
                <div class="strip-conts">
                    <div class="b-compare-header__row">
                        <slot></slot>
                    </div>    
                </div>
            </div>
        </transition>
    </div>`,
    mounted(){
        this.handleScroll()
        jQuery(window).on('scroll.compare-header', (e)=> {
            this.handleScroll()
        })
    },
    methods:{
        handleScroll(){
            this.show = false
            //var scroll = jQuery(window).scrollTop();
            let element = document.querySelector(this.watchSelector)            
			if ( element.getBoundingClientRect().top < 0) {
                this.show = true
			}
        }
    },
    computed: {
    }
}